import { Component, OnInit } from '@angular/core';
import { AlertaService } from 'src/app/api-service/alerta.service';
import { AlertaModel } from 'src/app/models/alerta.model';
import { ShowModalService } from 'src/app/services/show-modal.service';

@Component({
  selector: 'app-modal-alerta',
  templateUrl: './modal-alerta.component.html',
  styleUrls: ['./modal-alerta.component.scss'],
})
export class ModalAlertaComponent implements OnInit {
  title: string;
  id: number;
  titulo: string = '';
  mensagem: string = '';
  constructor(private alertaService: AlertaService, public showModalService: ShowModalService) {}

  ngOnInit() {
    if (this.id) {
      this.alertaService.getAlertaPorId(this.id).then((al) => {
        this.titulo = al.titulo;
        this.mensagem = al.mensagem;
      });
    }
  }
}
